export enum CustomLogotypeId {
  LICENSEE_LOGOTYPE_ID = 1,
  COLLOCATION_CENTER_LOGOTYPE_ID = 2,
  IES_LOGOTYPE_ID = 3,
}
